import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

const COLORS = ["#00C49F", "#FFBB28", "red", "#FF8042"];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(2)}%`}
    </text>
  );
};

export default function GRAP(props) {
  const greenPercentage = (Number(props.green_data));
  const redPercentage = (Number(props.red_data));
  const yellowPercentage = (Number(props.yello_data));

  const data = [
    { name: "Pagos realizados con días de anticipación", value: greenPercentage },
    { name: "Pagos realizados a fecha límite", value: yellowPercentage },
    { name: "Pagos fuera de tiempo límite", value: redPercentage },
  ];

  return (
    <div style={{width:"100%", margin:"0 auto"}}>
      <PieChart width={800} height={500} >
        <Pie
          data={data}
          cx={400}
          cy={200}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={160}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell  key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend verticalAlign="bottom" height={36} HorizontalAlignmentType={"center"}/>

      </PieChart>
    </div>
  );
}
